// client-side local time
(function() {
  var timezone = null;
  var targets = null;

  function apply() {
    // only show local time for UK users
    // (timezone = Europe/London), who visit .com domain

    if (timezone == null || targets == null) return;
    targets.each(function() {
      // UTC time
      var timestamp = $(this).data('timestamp');
      var offset = timezone.utc_offset;
      if (timestamp && offset) {
        // use IP detected time zone offset
        var local_time = new Date(Date.parse(timestamp) + offset * 1000);
        local_time = (local_time.getUTCHours() < 10? "0": "") +
                     local_time.getUTCHours() + ":" +
                     (local_time.getUTCMinutes() < 10? "0": "") +
                     local_time.getUTCMinutes();
        // since local time is only shown to UK users on .com domain,
        // hard-code "GMT" suffix here
        $(this).parent().text($(this).text().replace('@@TIME@@', local_time + " BST"));
      }
    });
  }

  var copy_params = ['geoip_time_zone', 'ab_geoip_time_zone'];
  var query_string = '';
  for (var i = 0; i < copy_params.length; i++) {
    var value = qs(copy_params[i]);
    if (value) query_string += ((query_string == '')? '?': '&') + copy_params[i] + '=' + encodeURIComponent(value);
  }

  jQuery(function($) {
    targets = $('*[data-client-localtime]');

    // only show local time for UK users
    // (timezone = Europe/London), who visit .com domain
    if (window.location.host.match(/.*\.com$/)) {
      jQuery.get('/catalog/user/user_info' + query_string, function(data) {
        timezone = data.time_zone;
        if (timezone && timezone.name == "Europe/London") {
          console.log("Using time zone: " + timezone.name + ", offset: " + timezone.utc_offset);
          apply();
        }
      });
    }
  });

  // NOTE: should be part of main lib
  function qs(key) {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
    var match = location.search.match(new RegExp("[?&]"+key+"=([^&]+)(&|$)"));
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
  }
})();
